module.exports = __webpack_public_path__ + "img/confernce_room_1.7d60b397.jpg";